var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNativeSupportinline = function SvgNativeSupportinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E0E5EB",
    strokeWidth: 2,
    d: "m13.797 61.5 26.128-42.107L66.197 61.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D7E0",
    d: "M21.977 54.773a1 1 0 0 0 .875 1.799zM36.363 50a1 1 0 0 0-.875-1.798zm20.799 6.581a1 1 0 1 0 .85-1.81zm-12.835-8.237a1 1 0 1 0-.85 1.81zm-5.33-5.044a1 1 0 1 0 2 0zm2-13.486a1 1 0 1 0-2 0zM22.853 56.572l13.51-6.573-.874-1.798-13.511 6.572zm35.16-1.802-13.685-6.427-.85 1.81 13.685 6.427zM40.998 43.3V29.812h-2v13.486z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7B1BE",
    d: "M36.363 49.998a1 1 0 1 0-.875-1.798zm7.965-1.656a1 1 0 1 0-.85 1.81zm-5.33-5.044a1 1 0 1 0 2 0zm-10.265 8.188a1 1 0 1 0 .874 1.799zm12.265-14.931a1 1 0 1 0-2 0zm9.322 16.81a1 1 0 0 0 .85-1.81zm-20.713-.08 6.756-3.287-.875-1.798-6.755 3.286zm11.39-9.987v-6.743h-2v6.743zm10.173 8.257-6.842-3.213-.85 1.81 6.842 3.214z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#A7B1BE",
    strokeWidth: 2,
    d: "M43.875 47.531c0-2.172-1.744-3.918-3.877-3.918s-3.877 1.746-3.877 3.918 1.744 3.918 3.877 3.918 3.877-1.746 3.877-3.918Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBDADA",
    stroke: "#EB4748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M58 64.522v-8.038a.5.5 0 0 1 .221-.415l8-5.378a.5.5 0 0 1 .558 0l8 5.378a.5.5 0 0 1 .221.415v8.038a.5.5 0 0 1-.221.415l-8 5.378a.5.5 0 0 1-.558 0l-8-5.378a.5.5 0 0 1-.221-.415"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EB4748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m58 56.219 8.5 5.193m0 0 8.5-5.193m-8.5 5.193v9.092"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A7B1BE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m51.927 49.737.75 3.929-3.926.763M28.136 49.469l-1.02 3.867 3.864 1.036M42.828 37.672l-2.804-2.852-2.829 2.828"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6FFFC",
    stroke: "#00877C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M31.498 23.518V15.48a.5.5 0 0 1 .221-.415l8-5.377a.5.5 0 0 1 .558 0l8 5.377a.5.5 0 0 1 .221.415v8.038a.5.5 0 0 1-.221.415l-8 5.378a.5.5 0 0 1-.558 0l-8-5.378a.5.5 0 0 1-.221-.415"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00877C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m31.498 15.215 8.5 5.193m0 0 8.5-5.193m-8.5 5.193V29.5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF5D6",
    stroke: "#FFBF00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 64.519V56.48a.5.5 0 0 1 .221-.415l8-5.377a.5.5 0 0 1 .558 0l8 5.377a.5.5 0 0 1 .221.415v8.039a.5.5 0 0 1-.221.414l-8 5.378a.5.5 0 0 1-.558 0l-8-5.378A.5.5 0 0 1 5 64.52"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBF00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m5 56.215 8.5 5.193m0 0 8.5-5.193m-8.5 5.193V70.5"
  })));
};
export default SvgNativeSupportinline;